<template>
  <router-link
    v-if="hasLink"
    :data-bs-toggle="collapse ? 'collapse' : ''"
    :to="collapse ? `#${collapseRef}` : collapseRef"
    :aria-controls="collapseRef"
    :aria-expanded="isExpanded"
    class="nav-link m-0"
    active-class=""
    exact-active-class=""
    :class="isActualRoute ? `active bg-gradient-${color}` : ''"
    v-bind="$attrs"
    @click="toggleExpand"
  >
    <div class="text-center d-flex align-items-center justify-content-center" :class="isRTL ? 'ms-2' : 'me-2'">
      <slot name="icon"></slot>
    </div>
    <span class="nav-link-text" :class="isRTL ? 'me-1' : 'ms-1'">
      {{ navText }}
    </span>
    <slot></slot>
  </router-link>

  <div v-else class="nav-link m-0 bg-black cursor-pointer" @click="openUrl(urlToOpen)">
    <div class="text-center d-flex align-items-center justify-content-center" :class="isRTL ? 'ms-2' : 'me-2'">
      <slot name="icon"></slot>
    </div>
    <span class="nav-link-text" :class="isRTL ? 'me-1' : 'ms-1'">
      {{ navText }}
    </span>
    <slot></slot>
  </div>

  <div :class="isExpanded ? 'collapse show' : 'collapse'">
    <slot name="list"></slot>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "SidenavCollapse",
  props: {
    collapseRef: {
      type: String,
      default: null
    },
    navText: {
      type: String,
      required: true
    },
    collapse: {
      type: Boolean,
      default: true
    },
    hasLink: {
      type: Boolean,
      default: true
    },
    urlToOpen: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      isExpanded: false
    };
  },
  computed: {
    ...mapState(["isRTL", "color"]),
    isActualRoute() {
      if(!this.hasLink) return false;
      if (!this.collapseRef) return false;
      
      const [refPath, refQueryString] = this.collapseRef.split("?");
      const currentRouteBase = this.getRoute();
      const linkBase = refPath.split("/").filter(p => p).at(0); // gets 'settings' from '/settings'
      
      if (refQueryString) {
        // The menu link demands specific query string (e.g., ?tab=affiliate)
        const queryParams = new URLSearchParams(refQueryString);
        let match = currentRouteBase === linkBase;
        for (const [key, value] of queryParams.entries()) {
          if (this.$route.query[key] !== value) {
            match = false;
            break;
          }
        }
        return match;
      } else {
        // The menu link has NO query. But if the route DOES have a specific query, we might want to un-highlight.
        if (currentRouteBase === linkBase) {
          if (refPath === '/settings' && this.$route.query.tab === 'affiliate') {
            return false;
          }
          return true;
        }
        return false;
      }
    },
    getBackgroundColor() {
      return `active bg-gradient-${this.color}`;
    }
  },
  methods: {
    getRoute() {
      return this.$route.path.split("/")[1];
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
    openUrl(url) {
      window.open(url, '_blank');
    }
  }
};
</script>
